<template>
  <div>
    <div class="fs-xs fc-gray-6 font-weight-bold" v-if="screen == 0">
      {{ searchType }}
    </div>
    <div class="d-flex align-center my-2" v-if="cId || worldId || shouhinKbn">
      <BaseIcon
        v-if="cId || worldId"
        :contentClass="namespace + '-Hero_Icon'"
        :type="cId ? 'character' : 'assets'"
        :itemId="cId ? cId : `${assetsPath}/w_assets/${worldId}/banner/1.png`"
      />

      <span v-if="cId" class="fs-l font-weight-bold pl-4">
        {{
          fullName(
            characterInfo.name,
            characterInfo.middleName,
            characterInfo.surname,
            characterInfo.nameOrder
          )
        }}
      </span>
      <span v-else-if="worldId" class="fs-l font-weight-bold pl-4">
        {{ firstItem.worldName }}
      </span>
      <span v-else-if="shouhinKbn" class="fs-l font-weight-bold pl-4">
        {{ firstItem.shouhinmei }}
      </span>
    </div>
    <div class="d-flex fs-xs align-baseline flex-wrap">
      <span class="fs-l font-weight-bold" v-if="screen == 1">{{
        showItemName(itemKbn)
      }}</span>

      <span class="fs-l font-weight-bold" v-if="screen != 1">{{
        keyword
      }}</span>

      <span v-if="type != 'all' || screen == 1" class="pl-2 fc-gray-4"
        >{{ totalCount | addComma }}件</span
      >
      <v-flex class="text-right">
        <v-btn small text :color="ColorTextSub" @click="$emit('openDialog')">
          <v-icon left>search</v-icon>検索条件
        </v-btn>
      </v-flex>
    </div>
    <div v-if="screen == 1 && keyword">
      <span class="fs-s fc-gray-4">キーワード：{{ keyword }}</span>
    </div>

    <div v-if="type != 'all' || screen == 1" class="fs-s">
      <span class="pr-2 fc-gray-4" v-if="selectCreatorKbn">{{
        selectCreatorKbn
      }}</span>

      <span class="pr-2 fc-gray-4" v-if="tags"
        >タグ：
        <template v-for="(item, index) in selectTags">
          <span :key="index">
            {{ showTagName(item) }}
          </span>
          <span :key="index + 0.5" v-if="index < selectTags.length - 1">,</span>
        </template>
      </span>
      <span class="pr-2 fc-gray-4" v-if="liked">お気に入り</span>
      <span class="fc-gray-4" v-if="ocWorld || ocItem"
        >受注中：
        <template v-for="(item, index) in selectOcWorld">
          <span :key="index + 0.1">
            {{ showWorldName(item) }}
          </span>
          <span :key="index + 0.2" v-if="index < selectOcWorld.length - 1"
            >,</span
          >
        </template>
        <span v-if="ocWorld && ocItem">/</span>
        <template v-for="(item, index) in selectOcItem">
          <span :key="index">
            {{ showItemName(item) }}
          </span>
          <span :key="index + 0.5" v-if="index < selectOcItem.length - 1"
            >,</span
          >
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "portalSearchResultView",
  props: {
    // 0:通常検索、1:発注可能リストの場合
    screen: {
      mode: Number,
      required: false,
      default: 0,
    },
    type: {
      mode: String,
      required: false,
      default: "default",
    },
    keyword: {
      mode: String,
      required: false,
      default: "",
    },
    creatorKbn: {
      mode: Number,
      required: false,
    },
    tags: {
      mode: Array,
      required: false,
    },
    liked: {
      mode: Boolean,
      default: false,
    },
    opend: {
      mode: Boolean,
      default: false,
    },
    ocItem: {
      mode: Array,
      required: false,
    },
    ocWorld: {
      mode: Array,
      required: false,
    },
    totalCount: {
      mode: Number,
      required: false,
    },

    // shouhinKbnLists: {
    //   mode: Array,
    //   required: false,
    // },
    itemKbn: {
      mode: String,
      required: false,
      default: "",
    },
    //商品種別（販売が期間終了しているものも入れる／開始前はいれない）
    shouhinKbnList: {
      mode: Array,
      default: [],
    },
    //ワールド（運営が終了しているものも入れる／開始前はいれない）
    worldList: { mode: Array, default: [] },
    //タグデータ
    creatorTagsList: { mode: Array, default: [] },

    cId: {
      mode: String,
      default: "",
      required: false,
    },
    worldId: {
      mode: String,
      default: "",
      required: false,
    },
    creatorId: {
      mode: Number,
      default: "",
      required: false,
    },
    shouhinKbn: {
      mode: String,
      default: "",
      required: false,
    },
    firstItem: {
      mode: Object,
      default: "",
      required: false,
    },
  },
  data() {
    return {
      searchDialog: false,
      loading: false,

      //キーワード
      search: "",

      //作品セグメント
      item: [],
      world: [],

      //クリエイターセグメント
      userClass: 0,
      creatorTag: [],
      likedCheck: false,
      openCheck: false,

      openCheckItem: [],
      openCheckWorld: [],

      //TODO:クリエイター種別
      creatorKbnList: [
        { value: 0, text: "全てのクリエイター" },
        { value: 1, text: "イラストレーター" },
        { value: 2, text: "ボイスアクター" },
        { value: 3, text: "ライター" },
        // { value: 4, text: "マスター" },
      ],

      characterInfo: "",
    };
  },

  computed: {
    searchType() {
      switch (this.type) {
        case "all":
          return "全体検索";
        case "illust":
          return "イラスト検索";
        case "voice":
          return "ボイス検索";
        case "novel":
          return "ノベル検索";
        case "creator":
          return "クリエイター検索";
        default:
          return "";
      }
    },
    selectCreatorKbn() {
      if (this.creatorKbn && this.creatorKbn != 0) {
        const result = this.creatorKbnList.filter(
          (v) => v.value == Number(this.creatorKbn)
        );
        return result[0].text;
      } else if (this.mode === "creator") {
        return this.creatorKbnList[0].text;
      }
    },
    selectTags() {
      if (this.tags) {
        return this.tags.split(",");
      }
    },
    selectOcItem() {
      if (this.ocItem) {
        return this.ocItem.split(",");
      } else {
        return [];
      }
    },
    selectOcWorld() {
      if (this.ocWorld) {
        return this.ocWorld.split(",");
      }
    },
  },
  watch: {
    cId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getCharaInfo(val);
        }
      },
    },
  },
  methods: {
    async getCharaInfo(cId) {
      await axios({
        method: "post",
        url: this.serverPath + "/api/community/findCharacterInfo",
        data: "&characterId=" + cId,
      }).then((response) => {
        this.characterInfo = response.data;
      });
    },

    showTagName(code) {
      const result = this.creatorTagsList.filter((v) => v.tagCode == code);
      return result[0].tagName;
    },

    showWorldName(code) {
      const result = this.worldList.filter((v) => v.worldId == code);
      return result[0].worldName;
    },

    showItemName(code) {
      if (this.shouhinKbnList.length > 0) {
        const result = this.shouhinKbnList.filter((v) => v.value == code);
        return result[0].text;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/sass/import.scss";
</style>
